import { render, staticRenderFns } from "./informatie-over-makelaars.vue?vue&type=template&id=7940e7c4"
import script from "./informatie-over-makelaars.vue?vue&type=script&lang=js"
export * from "./informatie-over-makelaars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports